import { render, staticRenderFns } from "./TgListCard.vue?vue&type=template&id=52c95ad8"
import script from "./TgListCard.vue?vue&type=script&lang=js"
export * from "./TgListCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports